module.exports = __webpack_public_path__ + "fonts/effect-masters-of-the-sword-35786c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-masters-of-the-sword.svg
// module id = 788
// module chunks = 0